import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    companiesFetched,
    companiesFetchRequestFailed,
    fetchCompanies,
} from '../approvedCompanies';
import { getSelectedProvince } from '../user-settings';

function* fetchCompaniesEffect({ payload }) {
    // Select the globally-selected province from the Redux store.
    const selectedProvince = yield select(getSelectedProvince);
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.users,
            method: 'GET',
            queryParams: {
                ...payload,
                // Prefer an explicit province filter from the filter bar; otherwise fall
                // back to the global province unless it is the "All" sentinel.
                ...(payload.province
                    ? { province: payload.province }
                    : selectedProvince !== 'All' && {
                          province: selectedProvince,
                      }),
            },
        });
        yield put(
            companiesFetched({
                results: response.results,
                totalRecords: response.totalRecords,
            }),
        );
    } catch (e) {
        yield put(companiesFetchRequestFailed());
    }
}

export const approvedCompaniesSagas = [
    takeEvery(fetchCompanies.type, fetchCompaniesEffect),
];
